import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28119fb0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content-container text-center" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "el-icon-document",
  style: {"font-size":"50px"}
}, null, -1 /* HOISTED */))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, " Not Found ", -1 /* HOISTED */))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Sorry, the requested item is not available for you! ", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`not-found ${(!$props.showBreadcrumb) ? 'is-auth' : ''} `)
  }, [
    _createCommentVNode(" <breadcrum v-if=\"showBreadcrumb\" :is-product-page=\"true\" :links=\"links\"></breadcrum> "),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: ($props.showBreadcrumb) ? {name: 'dashboard.index'} : {name: 'login.index'} ,
        id: "components-not-found-go-back"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_button, { type: "info" }, {
            default: _withCtx(() => [
              _createTextVNode(" Go Back ")
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["to"])
    ])
  ], 2 /* CLASS */))
}